import React, { useEffect, useState } from "react";
import { Row, Col, Skeleton } from "antd";
import {
  PlayCircleOutlined,
  LineChartOutlined,
  UserOutlined,
  BarChartOutlined,
  ClockCircleOutlined,
  AimOutlined,
} from "@ant-design/icons";
import styled from "styled-components";
import AnalyticsCard from "./AnalyticsCard";
import journeyServices from "../../../../services/journey";
import { extractToken } from "../../../../utils/localStorage";
import { globalRoles } from "../../../../utils/roles";

const AnalyticsSection = styled.div`
  margin-top: 32px;
  margin-bottom: 40px;
`;

const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: var(--primary-text-color);
  margin: 0 0 8px 0;
`;

const SectionSubtitle = styled.p`
  font-size: 14px;
  color: var(--secondary-text-color);
  margin: 0 0 24px 0;
`;

const Analytics = () => {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(false);
  const user = extractToken();
  const isSuperAdmin = user?.role === globalRoles.SUPERADMIN;
  const isPhysician = user?.role === globalRoles.PHYSICIAN;
  const isAssistant = user?.role === globalRoles.ASSISTANT;
  const isCcmCoordinator = user?.role === globalRoles.CCM_COORDINATOR;
  const isCcmManager = user?.role === globalRoles.CCM_MANAGER;
  const isLibraryManager = user?.role === globalRoles.LIBRARY_MANAGER;

  const fetchAnalytics = async () => {
    try {
      setLoading(true);
      const response = await journeyServices.getJourneyAnalytics();
      setAnalytics(response?.data);
    } catch (error) {
      console.error("Error fetching analytics:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnalytics();
  }, []);

  return (
    <>

    {
      (isSuperAdmin || isLibraryManager || isPhysician || isAssistant) && (
        <>
         <AnalyticsSection>
        <SectionTitle>Clinical Journeys Analytics</SectionTitle>
        <SectionSubtitle>
          Overview of patient education journeys
        </SectionSubtitle>
        {loading ? (
          <Row gutter={[16, 16]}>
            {[1, 2, 3, 4].map((i) => (
              <Col xs={24} sm={12} lg={6} key={i}>
                <Skeleton active avatar paragraph={{ rows: 1 }} />
              </Col>
            ))}
          </Row>
        ) : (
          <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <AnalyticsCard
              icon={<PlayCircleOutlined />}
              value={analytics?.activeJourneys || 0}
              title="Active Journeys"
              bgColor="#E0F2FE"
              iconColor="#0369A1"
              valueColor="#0369A1"
            />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <AnalyticsCard
              icon={<LineChartOutlined />}
              value={analytics?.avgCompletion?`${analytics?.avgCompletion || 0}%`: 0}
              title="Avg Completion"
              bgColor="#D1FAE5"
              iconColor="#10B981"
              valueColor="#10B981"
            />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <AnalyticsCard
              icon={<UserOutlined />}
              value={analytics?.totalPatients || 0}
              title="Total Patients"
              bgColor="#EDE9FE"
              iconColor="#8A3EF4"
              valueColor="#8A3EF4"
            />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <AnalyticsCard
              icon={<BarChartOutlined />}
              value={analytics?.completedJourneys || 0}
              title="Completed"
              bgColor="#FEF3C7"
              iconColor="#F59E0B"
              valueColor="#F59E0B"
            />
          </Col>
        </Row>
        )}
      </AnalyticsSection>
        </>
      ) 
    }

    {
      (isSuperAdmin || isLibraryManager || isCcmCoordinator || isCcmManager) && (
        <>
         <AnalyticsSection>
        <SectionTitle>CCM Plans Analytics</SectionTitle>
        <SectionSubtitle>
          Chronic Care Management program metrics
        </SectionSubtitle>
        {loading ? (
          <Row gutter={[16, 16]}>
            {[1, 2, 3].map((i) => (
              <Col xs={24} sm={12} lg={8} key={i}>
                <Skeleton active avatar paragraph={{ rows: 1 }} />
              </Col>
            ))}
          </Row>
        ) : (
          <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={8}>
            <AnalyticsCard
              icon={<ClockCircleOutlined />}
              value={analytics?.totalVideoMinutes || 0}
              title="Total Minutes"
              subtitle="This month"
              bgColor="#E0F2FE"
              iconColor="#0369A1"
              valueColor="#0369A1"
            />
          </Col>
          <Col xs={24} sm={12} lg={8}>
            <AnalyticsCard
              icon={<LineChartOutlined />}
              value={analytics?.billablePlans || 0}
              title="Billable Plans"
              subtitle="20+ minutes tracked"
              bgColor="#D1FAE5"
              iconColor="#10B981"
              valueColor="#10B981"
            />
          </Col>
          {/* <Col xs={24} sm={12} lg={6}>
            <AnalyticsCard
              icon={<AimOutlined />}
              value="5/21"
              title="Goals Achieved"
              subtitle="24% success rate"
              bgColor="#EDE9FE"
              iconColor="#8A3EF4"
              valueColor="#8A3EF4"
            />
          </Col> */}
          <Col xs={24} sm={12} lg={8}>
            <AnalyticsCard
              icon={<LineChartOutlined />}
              value={analytics?.avgWatchTimePerPatient || 0}
              title="Avg Minutes/Patient"
              subtitle="Per active plan"
              bgColor="#FEF3C7"
              iconColor="#F59E0B"
              valueColor="#F59E0B"
            />
          </Col>
        </Row>
        )}
      </AnalyticsSection>
        </>
      
      )
    }
     

     
    </>
  );
};

export default Analytics;

